module.exports = "<p class=\"info info--ok\" translate>auth.recoverPassword.success</p>\n"


//////////////////
// WEBPACK FOOTER
// /var/www/borneo/prod/borneo_app/src/app/auth/recover-password/recover-password-done/recover-password-done.component.html
// module id = ../../../../../src/app/auth/recover-password/recover-password-done/recover-password-done.component.html
// module chunks = main